import React, { useState, useEffect, useRef } from 'react';
import '../../css/public/contact.css';
import TopBar from './NavBar';
import Footer from './../components/Footer';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Contact = () => {
  
  const ServerApiDomain = process.env.REACT_APP_SPRING_SERVER_API_DOMAIN;
  const [currentStep, setCurrentStep] = useState(1); // Step tracking
  
  const [selectedCardOne, setSelectedCardOne] = useState(''); // Manage selected card state
  const [ErrorStepOne, setErrorStepOne] = useState("");
  
  const [SubmitDisabled, setSubmitDisabled] = useState(false);
  const [SubmitButtonText, setSubmitButtonText] = useState("Submit");
  // Define your cards data
  const cardsOne = [
    { id: 1, icon: "bi bi-info-circle", title: "General Support", description: "For any general inquiries" },
    { id: 2, icon: "bi bi-code-slash", title: "Technical Support", description: "For Technical Issues" },
    { id: 3, icon: "bi bi-megaphone", title: "PR Inquiries", description: "Interested in collaborating" },
    { id: 4, icon: "bi bi-credit-card", title: "Payment & Billing", description: "For payments or invoice" },
    { id: 5, icon: "bi bi-emoji-smile", title: "Product Feedback", description: "Help us to Improve" },
    { id: 6, icon: "bi bi-question-circle", title: "Something Else", description: "For Other Inquiries" },
  ];

  // Function to handle card selection
  const handleCardOneClick = (title) => {
    setSelectedCardOne(title);
  };
  
  const [selectedCardTwo, setSelectedCardTwo] = useState(""); // Manage selected card state

  // Define your new cards data
  const cardsTwo = [
    { id: 2, icon: "bi bi-envelope-at", title: "Email", description: "Available Mon-Sat" },
    { id: 3, icon: "bi bi-info-circle", title: "FAQs", description: "Available 24/7" },
  ];

  // Function to handle card selection
  const handleCardTwoClick = (id) => {
    setSelectedCardTwo(id);
  };
  
  const [TicketId, setTicketId] = useState('');
  useEffect(() => {
    document.title = 'Contact Us | Aadow';
    const generateTicketId = () => {
      const min = 10000000; // Minimum value for 8 digits
      const max = 9999999999; // Maximum value for 10 digits
      const randomTicketId = Math.floor(Math.random() * (max - min + 1)) + min;
      setTicketId(randomTicketId.toString());
    };

    // Generate the ticket ID when the component mounts
    generateTicketId();
  }, []);
  
  useEffect(() => {
    if (TicketId) {
		
      setTicketIdInput(TicketId);
    }
  }, [TicketId]);


  
  const [TicketIdInput, setTicketIdInput] = useState('');
  
  
  const [Name, setName] = useState('');
  const [NameError, setNameError] = useState(false);
  const [ErrorName, setErrorName] = useState('');
  const NameRef = useRef(null);
  
  
  const [Email, setEmail] = useState('');
  const [EmailError, setEmailError] = useState(false);
  const [ErrorEmail, setErrorEmail] = useState('');
  const EmailRef = useRef(null);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  
  const [Phone, setPhone] = useState('');
  const [PhoneError, setPhoneError] = useState(false);
  const [ErrorPhone, setErrorPhone] = useState('');
  const PhoneRef = useRef(null);
  
  const [Message, setMessage] = useState('');
  const [MessageError, setMessageError] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState('');
  const MessageRef = useRef(null);
  
  const [AccountId, setAccountId] = useState('');
  const [AccountIdError, setAccountIdError] = useState(false);
  const [ErrorAccountId, setErrorAccountId] = useState('');
  const AccountIdRef = useRef(null);
  
  // Function to handle "Next" button click
   const handleSubmit = () => {
	   setNameError(false);
	   setErrorName("");
	   setEmailError(false);
	   setErrorEmail("");
	   setPhoneError(false);
	   setErrorPhone("");
	   setMessageError(false);
	   setErrorMessage("");
	   if (Name === '') {
	    setNameError(true);
	    setErrorName("Please enter a name");
		NameRef.current.focus();
		return;
	   }else if (Email === '') {
	    setEmailError(true);
	    setErrorEmail("Please enter a email address");
		EmailRef.current.focus();
		return;
	   }else if (!emailRegex.test(Email)) {
	    setEmailError(true);
	    setErrorEmail("Please enter a valid email address");
		EmailRef.current.focus();
		return;
	   }else if (Phone === '') {
	    setPhoneError(true);
	    setErrorPhone("Please enter a phone");
		PhoneRef.current.focus();
		return;
	   }else if (Message === '') {
	    setMessageError(true);
	    setErrorMessage("Please enter a Message");
		MessageRef.current.focus();
		return;
	   }
	   
	   setSubmitDisabled(true);
	   setSubmitButtonText("Submitting...");
	   submitSupportTicket();
   };
  
  const handleNext = () => {
	 setErrorStepOne(""); 
	 if(currentStep === 1){
		 if (selectedCardOne === '') {
			 setErrorStepOne("Please Select an option");
			return;
		 }
	 }
    setCurrentStep((prevStep) => prevStep + 1);
  };

  // Function to handle "Back" button click
  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };
  
  const [ticketData, setTicketData] = useState({
    
  });
  
  const submitSupportTicket = async () => {
    
	
	const ticketData = {
		ticketId: TicketIdInput, // Ensure TicketIdInput is correctly set before this function
		queryCategory: selectedCardOne,
		name: Name,
		accountId: AccountId,
		email: Email,
		phone: Phone,
		message: Message,
		status: "Open",
	  };  
	  
    const username = "testuser"; // Replace with your actual username
    const password = "testpassword"; // Replace with your actual password
    const credentials = btoa(`${username}:${password}`); // Encode to Base64 for Basic Auth

    try {
      const response = await fetch(`${ServerApiDomain}/api/support-ticket/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Basic ${credentials}`, // Add Basic Auth header
        },
        body: JSON.stringify(ticketData),
      });

      if (response.ok) {
        sendEmail();
        const data = await response.json();
        setTicketId(data.ticketId);
        setCurrentStep(3);
      } else {
	    setErrorMessage("Failed to submit support ticket.");
		setSubmitDisabled(false);
		setSubmitButtonText("Submit");
      }
    } catch (error) {
	  setErrorMessage("Failed to submit support ticket.");
	  setSubmitDisabled(false);
	  setSubmitButtonText("Submit");
    }
  };
  
  const sendEmail = async () => {
    const apiUrl = `${ServerApiDomain}/api/send-email`;
    const emailData = {
      api: "hAROBT8OSEsBnAO-Bb9ktLsTvghYwqU-XcoJMPKeIl3qxF5",
      senderEmail: "no-reply@aadow.com",
      senderName: "Aadow",
      receiverEmail: Email,
      subject: `We’ve Received Your Support Ticket #${TicketId}`,
      emailContent: `<!DOCTYPE html><html lang='en'> <head> <meta charset='UTF-8'> <meta name='viewport' content='width=device-width, initial-scale=1.0'> <title>OTP Verification - Aadow</title> <style> /* General reset */ * { margin: 0; padding: 0; box-sizing: border-box; } body { font-family: 'Verdana', Tahoma, Geneva, Verdana, sans-serif; background-color: #f4f7fc; color: #333; line-height: 1.6; padding: 0; margin: 0; } .email-container { max-width: 600px; width: 100%; margin: 30px auto; background-color: #ffffff; border-radius: 12px; box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); border:0.1vw solid #f1f1f1; overflow: hidden; } .email-header { background-color: rgba(2, 98, 105); color: #ffffff; text-align: center; padding: 40px 30px; } .email-header img { max-width: 120px; margin-bottom: 20px; } .email-header h2 { font-size: 28px; font-weight: 700; letter-spacing: 1px; margin-bottom: 15px; } .email-content { padding: 30px; font-size: 16px; color: #333; text-align: left; } .otp-container { background-color: #e9eff4; padding: 20px; font-size: 40px; font-weight: bold; text-align: center; border-radius: 8px; margin: 30px 0; color: rgba(2, 98, 105); letter-spacing: 5px; box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05); } .cta-button { display: inline-block; background-color: rgba(2, 98, 105); color: #ffffff; padding: 12px 24px; border-radius: 50px; text-decoration: none; text-align: center; font-weight: bold; font-size: 16px; transition: background-color 0.3s ease, transform 0.2s ease; margin-top: 25px; } .cta-button:hover { background-color: rgba(2, 98, 105); transform: translateY(-3px); } .cta-button:active { transform: translateY(2px); } .email-footer { background-color: #f4f7fc; text-align: center; font-size: 14px; color: #888; padding: 20px; } .email-footer a { color: rgba(2, 98, 105); text-decoration: none; } /* Mobile responsiveness */ @media (max-width: 600px) { .email-header h2 { font-size: 4vw; } .otp-container { font-size: 10vw; padding: 15px; } p{ font-size: 3.2vw; line-height: 5vw; } .cta-button { width: 100%; padding: 1.5vw; }.email-footer p{ font-size: 2.5vw; line-height: 4.5vw; } } </style> </head> <body> <div class='email-container'> <!-- Header --> <div class='email-header'> <img src='https://www.aadow.com/logo/aadow-logo-white.png' alt='Aadow Logo'> <h2>Support Ticket Confirmation</h2> </div> <!-- Body --> <div class='email-content'> <p><b>Namastey 🙏,</b></p><br> <p>We have received your support request and our team is already on it. Rest assured, we’ll get back to you as soon as possible with updates.</p><br> <p><strong>Support Ticket ID:</strong> ${TicketId}</p><br> <p>While we work on your request, feel free to browse our Frequently Asked Questions for quick help. Click the button below to explore our FAQs:</p> <!-- CTA Button --> <a href='https://www.aadow.com/faqs?source=support-ticket-confirmation-${TicketId}' style='text-decoration:none;color:white;' class='cta-button'>Visit FAQs</a><br><br> <p>Thank you for trusting us.</p><br> <p>Best regards,<br><b>Aadow Team</b></p> </div> <!-- Footer --> <div class='email-footer'> <p>&copy; 2024 <a href='https://aadow.com' target='_blank'>Horza Private Limited</a>. All rights reserved.</p> </div> </div> </body></html>` // Include your full email content here
    };
  
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(emailData),
      });
  
      if (response.ok) {
        const result = await response.json();
        console.log("Email sent successfully:", result);
      } else {
        console.error("Failed to send email:", response.statusText);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  return (
    <>
      <HelmetProvider>
          <Helmet>
            <title>Connect with Aadow - Your Partner in Email Marketing Success</title>
            <meta
              name="title"
              content="Connect with Aadow - Your Partner in Email Marketing Success"
            />
            <meta
              name="description"
              content="Have questions or need help with email marketing? Contact Aadow for expert assistance and tailored solutions. We're here to empower your campaigns!"
            />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.aadow.com/contact" />
            <meta
              property="og:title"
              content="Connect with Aadow - Your Partner in Email Marketing Success"
            />
            <meta
              property="og:description"
              content="Have questions or need help with email marketing? Contact Aadow for expert assistance and tailored solutions. We're here to empower your campaigns!"
            />
            <meta
              property="og:image"
              content=""
            />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content="https://www.aadow.com/contact" />
            <meta
              property="twitter:title"
              content="Connect with Aadow - Your Partner in Email Marketing Success"
            />
            <meta
              property="twitter:description"
              content="Have questions or need help with email marketing? Contact Aadow for expert assistance and tailored solutions. We're here to empower your campaigns!"
            />
            <meta
              property="twitter:image"
              content=""
            />
          </Helmet>
      </HelmetProvider>
    <div className="contact-body">
      <TopBar />
      <div className="main-area">
        <div className="row">
          {/* Left Area */}
          <div className="col-12 col-md-12 col-lg-3 col-xl-3 order-2 order-md-2 order-lg-1 order-xl-1 m-0 p-0 ps-2">
            <div className="left-area">
              <div className="main-content">
                {/* Contact Option */}
                <div className="contact-option">
                  <div className="row">
                    <div className="col-3 col-md-3 col-lg-2 col-xl-2">
                      <a href="mailto:support@aadow.com"><i className="bi bi-envelope-at"></i></a>
                    </div>
                    <div className="col-9 col-md-9 col-lg-10 col-xl-10">
                      <h6 className="heading">Mail us</h6>
                      <h6 className="description">Our friendly team is here to help</h6>
                      <b className="contact-link">support@aadow.com</b>
                    </div>
                  </div>
                </div>

                <div className="contact-option">
                  <div className="row">
                    <div className="col-3 col-md-3 col-lg-2 col-xl-2">
                      <a href="https://wa.me/916360877920" target="_blank"><i className="bi bi-whatsapp"></i></a>
                    </div>
                    <div className="col-9 col-md-9 col-lg-10 col-xl-10">
                      <h6 className="heading">WhatsApp</h6>
                      <h6 className="description ">Say 'Hi' on WhatsApp!</h6>
                      <b className="contact-link">+91-6360877920</b>
                    </div>
                  </div>
                </div>
                {/* Other Contact Options */}
                <div className="contact-option">
                  <div className="row">
                    <div className="col-3 col-md-3 col-lg-2 col-xl-2">
                      <a ><i className="bi bi-geo-alt"></i></a>
                    </div>
                    <div className="col-9 col-md-9 col-lg-10 col-xl-10">
                      <h6 className="heading">Office</h6>
                      <h6 className="description">Come say hello to our HQ</h6>
                      <b className="contact-link">Horza Pvt Ltd, Devinagar, Bangalore, KA-560094 INDIA</b>
                    </div>
                  </div>
                </div>
              </div>

              <div className="footer-content">
                <a href="https://www.facebook.com/officialaadow/" target='_blank'><i className="bi bi-facebook"></i></a>
                <a href="https://x.com/aadow_com" target='_blank'><i className="bi bi-twitter-x"></i></a>
                <a href="https://www.linkedin.com/company/aadow" target='_blank'><i className="bi bi-linkedin"></i></a>
                <a href="https://www.instagram.com/officialaadow/" target='_blank'><i className="bi bi-instagram"></i></a>
                <a href="https://www.youtube.com/c/Aadow" target='_blank'><i className="bi bi-youtube"></i></a>
              </div>
            </div>
          </div>

          {/* Right Area */}
          <div className="col-12 col-md-12 col-lg-9 col-xl-9 order-1 order-md-1 order-lg-2 order-xl-2 m-0 p-0">
            <div className="right-area">
              <div className="main-content">
                {/* Conditionally Render Steps */}
                {currentStep === 1 && (
                  <div className="steps-area">
                    <h2>Get in Touch with Our Team</h2>
                    <div className="row">
									{cardsOne.map((card) => (
										<div key={card.id} className="col-6 col-md-6 col-lg-4 col-xl-4">
										  <div
											className={`radio-card ${selectedCardOne === card.id ? "active" : ""}`} // Apply active class if selected
											onClick={() => handleCardOneClick(card.id)}
										  >
											<i className={card.icon}></i>
											<h4>{card.title}</h4>
											<h6>{card.description}</h6>
										  </div>
										</div>
									  ))}
								</div>
								{ErrorStepOne && <div className="error-message">{ErrorStepOne}</div>}
                    <center>
                      <button className="primary-button w-50" onClick={handleNext}>Continue</button>
                    </center>
                  </div>
                )}

                

                {currentStep === 2 && (
                  <div className="steps-area">
                    <h2>Get in Touch with Our Team</h2>
                   <form className="mb-2">
										<div className="row">
											<div className="col-12 col-md-12 col-lg-6 col-xl-6">
												<label>Name<b className="text-danger">*</b></label>
												<input type="text" ref={NameRef} className={`input-form w-100 ${NameError ? 'input-error' : ''}`} value={Name} 
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit();  // Trigger the login on Enter press
                          }
                        }}
                        onChange={(e) => {
													  setName(e.target.value);
													}} />
												{ErrorName && <div className="error-message">{ErrorName}</div>}
											</div>
											<div className="col-12 col-md-12 col-lg-6 col-xl-6">
												<label>Email Address<b className="text-danger">*</b></label>
												<input type="text" ref={EmailRef} className={`input-form w-100 ${EmailError ? 'input-error' : ''}`} value={Email} 
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit();  // Trigger the login on Enter press
                          }
                        }}
                        onChange={(e) => {
													  setEmail(e.target.value);
													}} />
												{ErrorEmail && <div className="error-message">{ErrorEmail}</div>}
											</div>
											<div className="col-6">
												<label>Phone Number<b className="text-danger">*</b></label>
												<input type="text" ref={PhoneRef} className={`input-form w-100 ${PhoneError ? 'input-error' : ''}`} value={Phone} 
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit();  // Trigger the login on Enter press
                          }
                        }}
                        onChange={(e) => {
													  setPhone(e.target.value);
													}} />
												{ErrorPhone && <div className="error-message">{ErrorPhone}</div>}
											</div>
											<div className="col-6">
												<label>Account ID</label>
												<input type="text" ref={AccountIdRef} className={`input-form w-100 ${AccountIdError ? 'input-error' : ''}`} value={AccountId} 
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit();  // Trigger the login on Enter press
                          }
                        }}
                        onChange={(e) => {
													  setAccountId(e.target.value);
													}} />
													
													<input type="text" className={`input-form w-100 d-none`} value={TicketId} onChange={(e) => {
													  setTicketIdInput(e.target.value);
													}} />
												{ErrorAccountId && <div className="error-message">{ErrorAccountId}</div>}
											</div>
											<div className="col-12">
												<label>Message<b className="text-danger">*</b></label>
												<textarea rows="3" ref={MessageRef} className={`input-form w-100 ${MessageError ? 'input-error' : ''}`} value={Message} onChange={(e) => {
													  setMessage(e.target.value);
													}} ></textarea>
												{ErrorMessage && <div className="error-message">{ErrorMessage}</div>}
											</div>
										</div>
									</form>
                    <div className="row">
                      <div className="col-6">
                        <button className="primary-outline-button w-100" onClick={handleBack}>Back</button>
                      </div>
                      <div className="col-6">
                        <button className="primary-button w-100" disabled={SubmitDisabled} onClick={handleSubmit}>{SubmitButtonText}</button>
                      </div>
                    </div>
                  </div>
                )}

                {currentStep === 3 && (
                  <div className="steps-area">
                    <div className="text-center success-area">
                      <img src="iconss/other/approved.png" className="success-icon" />
                      <h2 className="secondary-heading">Support Ticket Created with ID #{TicketId}</h2>
                      <h2 className="secondary-description">We have received your query, and one of our executives will get in touch with you using the contact information you provided.</h2>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Contact;
